import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import KenButton from "../components/KenButton";

// Define prop types
interface ErrorFallbackProps {
    error: Error;
    resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
    const { t } = useTranslation();

    return (
        <Box
            role="alert"
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column"
        >
            <Typography style={{ marginTop: 10 }}>
                Something_Wrong
            </Typography>
            {/* If you want to show error details during dev */}
            {/* <pre>{error.message}</pre> */}
            <KenButton onClick={resetErrorBoundary}>
                Try_Again
            </KenButton>
        </Box>
    );
}
